var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-contianer"},[(!_vm.isConfirm && _vm.computedOrderData.orderId)?_c('orderDetail',{attrs:{"orderId":Number(_vm.computedOrderData.orderId)}}):(_vm.computedOrderData.orderId)?_c('orderConfirm',{attrs:{"computedOrderData":_vm.computedOrderData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }